import type { FC, ReactNode } from "react";

import { cn } from "@/lib/utils";

interface BlockWithBorderProps {
  children?: ReactNode;
  classes?: string;
}

const BlockWithBorder: FC<BlockWithBorderProps> = ({ children, classes }) => {
  return (
    <div
      className={cn("border-b-[11px] border-[#F1F2F4] mb-[17px] pb-4", classes)}
    >
      {children}
    </div>
  );
};

export default BlockWithBorder;
